<template lang="html">
<div>
   <v-header backTo="Login profissional">
        <router-link  :to="{name: 'client-login'}" class="linkLogin">
          Entrar
        </router-link>
    </v-header>
  <v-page class="page-register" :profile="profile" :style="{ backgroundImage: `url(${img_background_url})` }">

    <div class="autoRegister">
    <v-login class="card-register">
      <div class="center">
          <div class="registerLeft">
            <div class="company">
              <p>E</p>
              <p>M</p>
              <p>P</p>
              <p>R</p>
              <p>E</p>
              <p>S</p>
              <p>A</p>
            </div>
            <div>
              <img class="photo" :src="img_url">
            </div>
          </div>
      <div class="registerRight">

        <!-- <v-text tag="h2" class="h4 title center mb-3">Crie sua conta</v-text> -->
        <div class= "titleRegister">
          Cadastre-se gratuitamente <br> para
           <span class="spanColor">contratar profissionais</span>
          </div>

        <v-input type="text" id="signup-first-name" placeholder="Nome" class="inputRegister" v-model="name"/>

        <v-input type="text" id="signup-last-name" placeholder="Sobrenome" v-model="lastname"/>

        <v-input type="email" id="signup-email" v-model="email" placeholder="E-mail"/>

        <v-input type="tel" id="signup-phone" placeholder="Celular/Whatsapp"  v-model="cel_phone"/>

        <v-input type="text" id="signup-site" placeholder="Site" v-model="site"/>

         <v-input
                  type="select"
                  :options="['Analista', 'CEO', 'CTO/CIO', 'Gerente/Manager', 'Gestor/Head', 'Outro']"
                  v-model="position"
                   class= "SelectRegister"
                  placeholder="Cargo"
                  />
         <v-input
                  type="select"
                  :options="['Comercial', 'C-level', 'Estratégico', 'Inovação', 'tecnologia/produto de TI', 'Outro']"
                  class= "SelectRegister"
                  v-model="area"
                  placeholder="Área"
                  />
        <v-row :size="1">
          <v-col :md="6">
          <v-input type="password" id="signup-password" placeholder="Senha" v-model="password"/>

          </v-col>
          <v-col :md="6">
            <v-input
              type="repassword"
              id="signup-repassword"
              :repassword="password"
              v-model="confirm_password"
              placeholder= "Repetir senha"/>


          </v-col>
        </v-row>
        <small>
          <v-input type="checkbox" id="login-remember" v-model="accepted_term">
            Declaro que li e concordo com os
            <v-link :to="{ name: 'accept' }" target="_blank"
              >termos de aceite da plataforma Vibbra</v-link
            >
          </v-input>
        </small>
        <v-button
          class="block primary"
          @click="signup()"
          style="background-color: #0377AA; color:white"
          :disabled="!accepted_term"
          >Criar conta</v-button
        >

        <v-text tag="p" class=" lastInfo "
          >Já possui uma conta? <v-link to="login"   style="color: #0377AA"><p class="registeHere">Faça seu login</p></v-link>
        </v-text>
      </div>
      </div>
    </v-login>
    </div>
  </v-page>
</div>
</template>

<script>
import apiClient from '@/api/client';
// import apiVibbrante from '@/api/vibbrante'

export default {
  props: {
    profile: String,
  },
  data() {
    return {
      name: '',
      lastname: '',
      city: '',
      email: '',
      password: '',
      confirm_password: '',
      accepted_term: false,
      cel_phone: '',
      img_url: require('../../assets/photoPeople/Lucas.png'),
      img_background_url: require('../../assets/background/fundoAzul.svg'),
      position: '',
      area: '',
    };
  },
  methods: {
    signup() {
      if (this.profile === 'client') {
        apiClient
          .sign_up(
            this.email,
            this.password,
            this.confirm_password,
            this.name,
            this.lastname,
            this.accepted_term,
            this.cel_phone,
            this.position,
            this.area,
            this.site
          )
          .then((response) => {
            if (response.status === 200) {
              this.$store.dispatch('registerClient', response);
              this.$router.push({ name: 'client-register-success' });
            }
          })
          .catch((e) => {
            this.$children[0].showErrorMsg({ message: e });
          });
      } else {
        /* apiVibbrante.sign_up(this.email, this.password, this.confirm_password, this.name, this.nickname, this.accepted_term).then((response) => {
          if (response.status === 200) {
            this.$store.dispatch('registerVibbrante', response)
            this.$router.replace('/vibbrant')
          }
        }).catch((e) => {
           this.$notify(e, 'error')
        }) */
      }
    },
  },
};
</script>

<style lang="scss">
.linkLogin {
color: white;
}
.page {
    min-height: calc(100vh - 60px);
}
.page-register {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .link {
   color:#0377aa !important;
  }

  .autoRegister {
    width: 75%;
  }
  .card-register {
    max-width: 100%;
    flex-basis: auto;
    flex-grow: 1;
    border-radius: 22px;
    @include media-breakpoint-up(md) {
      width: 100%;
    }
    .center {
    display: flex;
    align-items: center;
    padding: 2rem 2rem 0 0;

    @include media-breakpoint-down(md) {
      padding: 2rem;
    }
  }
  .registerLeft {
    display: flex;
    align-items: flex-end;

    height: 100%;
    width: 60%;
    @include media-breakpoint-down(md) {
      display: none;
    }

  }



    .photo {
      display: block;
      height: 700px;
      margin-top: 6px;
    }
    .company {
      background-color: #0377aa;
      color: white;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 10px 25px;
      height: calc(100vh - 450px);
      align-items: center;
      font-weight: 700px;
      font-weight: 700;
      font-size: 20px;
      border-radius: 0 10px 0 20px;

      p {
        margin: 0;
      }
    }
    .registerRight {
      width: 40%;
      @include media-breakpoint-down(md) {
        width: 100%;
      }
    }

 }
     .titleRegister{
        font-size: 35px;
        font-weight: bold;
        margin-bottom: 40px;

        @include media-breakpoint-down(md) {
          font-size: 30px;
        }

      }

 .spanColor{
          color:#0377aa;
        }

  .inputRegister{
    border-radius: 20px !important;
  }
  .profForgot {
      color: #0377aa;
    }

  .lastInfo {
    display: flex;
    gap: 1rem;
    margin-top:20px ;
  }

 .SelectRegister{
    .multiselect__placeholder{
    color: rgb(72, 72, 72) !important;
  }

 }
  footer.page-footer {
    margin-top: auto;
    color: white;
  }
  .registeHere{
    display: flex ;
    color: #0377aa !important;
  }

}
</style>



// WEBPACK FOOTER //
// src/parts/pages/register.vue